import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { getProductById } from "../api/productService";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import { openWhatsApp, createProductWhatsAppMessage } from "../utils/whatsapp";
import "./ProductDetails.css";
const ProductDetails = () => {
  const { id } = useParams();

  const { addToCart } = useCart();

  const { isInWishlist, toggleWishlist } = useWishlist();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProduct = async () => {
      try {
        const data = await getProductById(id);

        setProduct(data);
      } catch (error) {
        console.error("Error loading product:", error);
      } finally {
        setLoading(false);
      }
    };

    loadProduct();
  }, [id]);

  if (loading) {
    return (
      <main className="product-luxury-page">
        <div className="product-luxury-message">Discovering this piece...</div>
      </main>
    );
  }

  if (!product) {
    return (
      <main className="product-luxury-page">
        <div className="product-luxury-message">
          <h2>Product Not Found</h2>

          <Link to="/collections">Return to Collection</Link>
        </div>
      </main>
    );
  }

  const hasSalePrice =
    product.salePrice !== null &&
    product.salePrice !== undefined &&
    Number(product.salePrice) < Number(product.price);

  const wishlisted = isInWishlist(product.id);

  const handleAddToCart = () => {
    addToCart(product);

    alert(`${product.name} added to cart`);
  };

  const handleWishlist = () => {
    toggleWishlist(product);
  };

  return (
    <main className="product-luxury-page">
      <div className="product-luxury-container">
        {/* IMAGE */}

        <div className="product-luxury-image-area">
          <div className="product-luxury-image-frame">
            <img
              src={product.imageUrl}
              alt={product.name}
              className="product-luxury-image"
            />
          </div>
        </div>

        {/* INFORMATION */}

        <div className="product-luxury-info">
          <Link to="/collections" className="product-back-link">
            ← Back to Collection
          </Link>

          <p className="product-luxury-category">{product.category}</p>

          {/* PRODUCT NAME + WISHLIST */}

          <div className="product-details-title-row">
            <h1>{product.name}</h1>

            <button
              type="button"
              className={`product-details-wishlist ${
                wishlisted ? "wishlisted" : ""
              }`}
              onClick={handleWishlist}
              aria-label={
                wishlisted ? "Remove from wishlist" : "Add to wishlist"
              }
            >
              {wishlisted ? "♥" : "♡"}
            </button>
          </div>

          <div className="product-gold-line"></div>

          {product.description && (
            <p className="product-luxury-description">{product.description}</p>
          )}

          {/* PRICE */}

          <div className="product-luxury-price">
            {hasSalePrice ? (
              <>
                <span className="product-old-price">₹{product.price}</span>

                <span className="product-sale-price">₹{product.salePrice}</span>
              </>
            ) : (
              <span className="product-normal-price">₹{product.price}</span>
            )}
          </div>

          {/* STOCK */}

          <div
            className={
              Number(product.stock) > 0
                ? "product-stock"
                : "product-stock product-stock-out"
            }
          >
            {Number(product.stock) > 0
              ? `In Stock • ${product.stock} available`
              : "Currently Out of Stock"}
          </div>

          {/* BUTTON */}

          <button
            type="button"
            className="product-add-button"
            onClick={handleAddToCart}
            disabled={Number(product.stock) <= 0}
          >
            {Number(product.stock) > 0 ? "Add to Cart" : "Out of Stock"}
          </button>
          <button
            type="button"
            className="details-whatsapp-button"
            onClick={() => openWhatsApp(createProductWhatsAppMessage(product))}
          >
            Enquire on WhatsApp
          </button>

          {/* EXTRA INFO */}

          <div className="product-details-extra">
            <div>
              <span>01</span>
              <p>Premium Finish</p>
            </div>

            <div>
              <span>02</span>
              <p>Elegant Design</p>
            </div>

            <div>
              <span>03</span>
              <p>Made for Every Occasion</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ProductDetails;
